import { defineComponent as _defineComponent } from 'vue'
import { useRegistryUtils } from '@/composables/useRegistryUtils'
import { inject } from 'vue'
import { FireRiskDashboardViewModel } from '../../viewmodels/FireRiskDashboard.viewmodel'
import FarmFireRiskChartCard from '../FarmFireRiskChartCard.vue'
import Pagination from '@/components/ui/pagination/Pagination.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'FireRiskByFarm.view',
  setup(__props) {

const vm = inject<FireRiskDashboardViewModel>('fire-risk-dashboard-viewmodel')!

const { pageData, page, pageSize, onPageChange } = useRegistryUtils(vm.recentFireRisks, [])

pageSize.value = 3

return { __sfc: true,vm, pageData, page, pageSize, onPageChange, FarmFireRiskChartCard, Pagination }
}

})